import { getDistance,bearing } from './coordinate.js';

/**
 * 正序排
 * @param {需要排序的字段属性} property 
 * @returns 
 */
function compareAsc(property){
  return function(a,b){
    let value1 = a[property];
    let value2 = b[property];
    return value1 - value2;
  }
}

/**
 * 倒序排
 * @param {需要排序的字段属性} property 
 * @returns 
 */
function compareDesc(property){
  return function(a,b){
    let value1 = a[property];
    let value2 = b[property];
    return value2 - value1;
  }
}

/**
 * 缓存数据到本地
 * @param {key} key 
 * @param {值} value 
 */
function setStorageItem(key,value){
  sessionStorage.setItem(key,value);
}

/**
 * 正北角：两个坐标连线与正北方向的夹角
 * @param {*} dituDirect 车辆行驶方向正北角
 * @returns 
 */
function getDirection(dituDirect) {
  if (dituDirect >= 23 && dituDirect <= 67) {
    return "东北";
  } else if (dituDirect >= 68 && dituDirect <= 112) {
    return "正东";
  } else if (dituDirect >= 113 && dituDirect <= 157) {
    return "东南";
  } else if (dituDirect >= 158 && dituDirect <= 202) {
    return "正南";
  } else if (dituDirect >= 203 && dituDirect <= 247) {
    return "西南";
  } else if (dituDirect >= 248 && dituDirect <= 292) {
    return "正西";
  } else if (dituDirect >= 293 && dituDirect <= 337) {
    return "西北";
  } 

  return "正北";
}

/**
 * 模糊匹配方向
 * 角度左边90度和角度右边90度区域
 * @param {*} direction1 方向1(当前车行驶方向)
 * @param {*} direction2 方向2(车到下一站方向)
 */
function isSameDirection(direction1,direction2){
  let flag = false;
  let dueNorthDirection = ['西北','正北','东北']; //['正西','西北','正北','东北','正东'];
  let northeastDirection = ['正北','东北','正东']; //['西北','正北','东北','正东','东南'];
  let dueEastDirection = ['东北','正东','东南']; //['正北','东北','正东','东南','正南'];
  let southeastDirection = ['正东','东南','正南']; //['东北','正东','东南','正南','西南'];
  let dueSouthDirection = ['东南','正南','西南']; //['正东','东南','正南','西南','正西'];
  let southwestDirection = ['正南','西南','正西']; //['东南','正南','西南','正西','西北'];
  let dueWestDirection = ['西南','正西','西北']; //['正南','西南','正西','西北','正北'];
  let northwestDirection = ['正西','西北','正北']; //['西南','正西','西北','正北','东北'];
  // let dueNorthDirection = ['正西','西北','正北','东北','正东'];
  // let northeastDirection = ['西北','正北','东北','正东','东南'];
  // let dueEastDirection = ['正北','东北','正东','东南','正南'];
  // let southeastDirection = ['东北','正东','东南','正南','西南'];
  // let dueSouthDirection = ['正东','东南','正南','西南','正西'];
  // let southwestDirection = ['东南','正南','西南','正西','西北'];
  // let dueWestDirection = ['正南','西南','正西','西北','正北'];
  // let northwestDirection = ['西南','正西','西北','正北','东北'];
  switch(direction1) {
    case "正北":
      if(dueNorthDirection.indexOf(direction2) > -1)
        flag=true;
      break;
    case "东北":
      if(northeastDirection.indexOf(direction2) > -1)
        flag=true;
      break;
    case "正东":
      if(dueEastDirection.indexOf(direction2) > -1)
        flag=true;
      break;
    case "东南":
      if(southeastDirection.indexOf(direction2) > -1)
        flag=true;
      break;
    case "正南":
      if(dueSouthDirection.indexOf(direction2) > -1)
        flag=true;
      break;
    case "西南":
      if(southwestDirection.indexOf(direction2) > -1)
        flag=true;
      break;
    case "正西":
      if(dueWestDirection.indexOf(direction2) > -1)
        flag=true;
      break;
    case "西北":
      if(northwestDirection.indexOf(direction2) > -1)
        flag=true;
      break;
  }
  
  return flag;
}

function getSocketCoordinateDistanceData(lineSiteDate,simId,locationTime,speed,latitude,longitude,direction){
  let arr = [];
  if(lineSiteDate.length > 0) {
    lineSiteDate.forEach(item=>{
      let obj= Object.create(null);
      obj.simId = simId;
      obj.locationTime = locationTime;
      obj.speed = speed;
      obj.latitude = item.Latitude;
      obj.longitude = item.Longitude;
      obj.name = item.SiteChineseName; 
      obj.siteNumber = item.SiteNumber; 
      obj.distance = getDistance(latitude,longitude,item.Latitude,item.Longitude); 
      obj.previousStationSiteDistance = item.PreviousDistance;
      obj.toNextSiteDistance = item.NextDistance;; 
      obj.vehiclesDirection = direction; 
      obj.coordinateDirection = getDirection(bearing(latitude,longitude,item.Latitude,item.Longitude));
      arr.push(obj);
    })
  }

  return arr.sort(compareAsc("distance"));
}

/**
 * 获取最近站点和其前后、后后站点数据
 */
function getLatelyAroundData(socketCoordinateDistanceData){
  let latelyAroundData=[];
  let siteNumber=0;
  let firstFlag = true;
  socketCoordinateDistanceData.forEach(item=>{
    if(firstFlag){
      siteNumber = item.siteNumber;
      latelyAroundData.push(item);
      firstFlag = false;
    } else if(parseInt(item.siteNumber) === parseInt(siteNumber)-1){
      latelyAroundData.push(item);
    } else if(parseInt(item.siteNumber) === parseInt(siteNumber)+1){
      latelyAroundData.push(item);
    } else if(parseInt(item.siteNumber) === parseInt(siteNumber)+2 && parseInt(siteNumber)>1){
      latelyAroundData.push(item);
    }
  })

  return latelyAroundData.sort(compareAsc("siteNumber"));
}

function getVehiclesTravelPosition(type,simId,locationTime,socketCoordinateDistanceData,direction){
  let latelyAroundData = getLatelyAroundData(socketCoordinateDistanceData);
  let siteSpacing0=0; //第一个站点上一路段间距
  let siteSpacing1=0; //第一个站点下一路段间距
  let siteSpacing2=0; //第二个站点下一路段间距
  let siteSpacing3=0; //第三个站点下一路段间距
  let toSiteDistance1=0; //当前车位置到第一个站点距离
  let toSiteDistance2=0; //当前车位置到第二个站点距离
  let toSiteDistance3=0; //当前车位置到第三个站点距离
  let toNextSiteDirection=''; //当前车位置到下一个站点方向
  let toSiteDirection1=''; //当前车位置到第一个站点方向
  let toSiteDirection2=''; //当前车位置到第二个站点方向
  let toSiteDirection3=''; //当前车位置到第三个站点方向
  let toSiteDirection4=''; //当前车位置到第四个站点方向
  let siteNumber=0; //车辆坐落的路段上一个站点序号
  let nextSiteDistance=0; //车辆距离下一站距离

  if(latelyAroundData.length >= 3){
    siteSpacing0=latelyAroundData[0].previousStationSiteDistance;
    siteSpacing1=latelyAroundData[0].toNextSiteDistance;
    siteSpacing2=latelyAroundData[1].toNextSiteDistance;
    siteSpacing3=latelyAroundData[2].toNextSiteDistance;
    toSiteDistance1=latelyAroundData[0].distance;
    toSiteDistance2=latelyAroundData[1].distance;
    toSiteDistance3=latelyAroundData[2].distance;
    toSiteDirection1 = latelyAroundData[0].coordinateDirection;
    toSiteDirection2 = latelyAroundData[1].coordinateDirection;
    toSiteDirection3 = latelyAroundData[2].coordinateDirection;
    if(latelyAroundData.length === 4){
      toSiteDirection4 = latelyAroundData[3].coordinateDirection;
    }else{
      toSiteDirection4 = latelyAroundData[2].coordinateDirection;
    }

    if(parseFloat(toSiteDistance3) < parseFloat(siteSpacing3) && parseFloat(toSiteDistance2) > parseFloat(siteSpacing2) && !isSameDirection(direction,toSiteDirection3)){
      siteNumber = latelyAroundData[2].siteNumber;
      nextSiteDistance = parseFloat(siteSpacing3) - parseFloat(toSiteDistance3);
      toNextSiteDirection = toSiteDirection4;
    } else if(parseFloat(toSiteDistance2) < parseFloat(siteSpacing2) && parseFloat(toSiteDistance3) < parseFloat(siteSpacing2) && isSameDirection(direction,toSiteDirection3)){ // !isSameDirection(direction,toSiteDirection2)
      siteNumber = latelyAroundData[1].siteNumber;
      nextSiteDistance = parseFloat(toSiteDistance3);
      toNextSiteDirection = toSiteDirection3;
    } else if(parseFloat(toSiteDistance1) < parseFloat(siteSpacing1) && parseFloat(toSiteDistance2) < parseFloat(siteSpacing1) && isSameDirection(direction,toSiteDirection2)){ // !isSameDirection(direction,toSiteDirection1)
      siteNumber = latelyAroundData[0].siteNumber;
      nextSiteDistance = parseFloat(toSiteDistance2);
      toNextSiteDirection = toSiteDirection2;
    } else if(parseFloat(toSiteDistance1) < parseFloat(siteSpacing0) && parseFloat(toSiteDistance2) > parseFloat(siteSpacing1) && isSameDirection(direction,toSiteDirection1)){
      siteNumber = latelyAroundData[0].siteNumber-1;
      nextSiteDistance = parseFloat(toSiteDistance1);
      toNextSiteDirection = toSiteDirection1;
    }
  } else if(latelyAroundData.length === 2){
    //siteSpacing0=latelyAroundData[0].previousStationSiteDistance;
    siteSpacing1=latelyAroundData[0].toNextSiteDistance;
    toSiteDistance1=latelyAroundData[0].distance;
    toSiteDistance2=latelyAroundData[1].distance;
    toSiteDirection1 = latelyAroundData[0].coordinateDirection;
    //toSiteDirection2 = latelyAroundData[1].coordinateDirection;

    if(parseInt(latelyAroundData[0].siteNumber)===1){
      if(parseFloat(toSiteDistance2) <= parseFloat(siteSpacing1) && !isSameDirection(direction,toSiteDirection1)){
        siteNumber = 1;
        nextSiteDistance = parseFloat(toSiteDistance2);
      }else if(parseFloat(toSiteDistance2) > parseFloat(siteSpacing1) && parseInt(toSiteDistance1)<=20){
        siteNumber = 1;
        nextSiteDistance = parseFloat(toSiteDistance1)+parseFloat(toSiteDistance2);
      }
    }else{
      if(parseFloat(toSiteDistance2) <= parseFloat(siteSpacing1) && parseFloat(toSiteDistance1) < parseFloat(siteSpacing1) && !isSameDirection(direction,toSiteDirection1)){
        siteNumber = latelyAroundData[0].siteNumber;
        nextSiteDistance = parseFloat(toSiteDistance2);
      }else{
        siteNumber = latelyAroundData[1].siteNumber;
        nextSiteDistance = 0;
      }

      if(parseInt(nextSiteDistance)<=10){ //距离最后一站10m内，默认到站
        siteNumber = latelyAroundData[1].siteNumber;
      }
    }
    
    // if(parseFloat(toSiteDistance2) < parseFloat(siteSpacing1) && !isSameDirection(direction,toSiteDirection1)){
    //   siteNumber = latelyAroundData[0].siteNumber;
    //   nextSiteDistance = parseFloat(toSiteDistance2);
    //   if(parseInt(siteNumber)>1 && parseFloat(nextSiteDistance)<=15){ //距离最后一站15M内，默认到站
    //     siteNumber = latelyAroundData[1].siteNumber;
    //   }
    // }
  }

  if(parseInt(siteNumber)>0){
    storageLastTimeData(type,simId,locationTime,siteNumber,nextSiteDistance,toNextSiteDirection);
  }
  // consoleVehiclesTravelPositionData(simId,siteSpacing0,siteSpacing1,siteSpacing2,siteSpacing3,toSiteDistance1,toSiteDistance2,toSiteDistance3,toSiteDirection1,toSiteDirection2,toSiteDirection3,0,0);

  return siteNumber+","+nextSiteDistance;
} 

function getVehiclesTravelPositionByLastTimeData(type,simId,locationTime,socketCoordinateDistanceData,lastTimeData){
  let latelyAroundData = getLatelyAroundData(socketCoordinateDistanceData);
  let siteSpacing0=0; //第一个站点上一路段间距
  let siteSpacing1=0; //第一个站点下一路段间距
  let siteSpacing2=0; //第二个站点下一路段间距
  let siteSpacing3=0; //第三个站点下一路段间距
  let currentToSiteDistance1=0; //当前车位置到第一个站点距离
  let currentToSiteDistance2=0; //当前车位置到第二个站点距离
  let currentToSiteDistance3=0; //当前车位置到第三个站点距离
  let toNextSiteDirection=''; //当前车位置到下一个站点方向
  let toSiteDirection1=''; //当前车位置到第一个站点方向
  let toSiteDirection2=''; //当前车位置到第二个站点方向
  let toSiteDirection3=''; //当前车位置到第三个站点方向
  let toSiteDirection4=''; //当前车位置到第四个站点方向
  let siteNumber=0; //车辆坐落的路段上一个站点序号
  let nextSiteDistance=0; //车辆距离下一站距离

  let lastSiteNumber = lastTimeData[0].siteNumber; //上一次车辆坐落的路段上一个站点序号

  if(latelyAroundData.length >= 3){
    siteSpacing0=latelyAroundData[0].previousStationSiteDistance;
    siteSpacing1=latelyAroundData[0].toNextSiteDistance;
    siteSpacing2=latelyAroundData[1].toNextSiteDistance;
    siteSpacing3=latelyAroundData[2].toNextSiteDistance;
    currentToSiteDistance1=latelyAroundData[0].distance;
    currentToSiteDistance2=latelyAroundData[1].distance;
    currentToSiteDistance3=latelyAroundData[2].distance;
    toSiteDirection1 = latelyAroundData[0].coordinateDirection;
    toSiteDirection2 = latelyAroundData[1].coordinateDirection;
    toSiteDirection3 = latelyAroundData[2].coordinateDirection;
    if(latelyAroundData.length === 4){
      toSiteDirection4 = latelyAroundData[3].coordinateDirection;
    }else{
      toSiteDirection4 = latelyAroundData[2].coordinateDirection;
    }

    if(parseFloat(currentToSiteDistance3) < parseFloat(siteSpacing3) && parseFloat(currentToSiteDistance2) > parseFloat(siteSpacing2)){
      siteNumber = latelyAroundData[2].siteNumber;
      nextSiteDistance = parseFloat(siteSpacing3) - parseFloat(currentToSiteDistance3);
      toNextSiteDirection = toSiteDirection4;
    } else if(parseFloat(currentToSiteDistance2) < parseFloat(siteSpacing2) && parseFloat(currentToSiteDistance3) < parseFloat(siteSpacing2)){
      siteNumber = latelyAroundData[1].siteNumber;
      nextSiteDistance = parseFloat(currentToSiteDistance3);
      toNextSiteDirection = toSiteDirection3;
    } else if(parseFloat(currentToSiteDistance1) < parseFloat(siteSpacing1) && parseFloat(currentToSiteDistance2) < parseFloat(siteSpacing1)){
      siteNumber = latelyAroundData[0].siteNumber;
      nextSiteDistance = parseFloat(currentToSiteDistance2);
      toNextSiteDirection = toSiteDirection2;
    } else if(parseFloat(currentToSiteDistance1) < parseFloat(siteSpacing0) && parseFloat(currentToSiteDistance2) > parseFloat(siteSpacing1)){
      siteNumber = latelyAroundData[0].siteNumber-1;
      nextSiteDistance = parseFloat(currentToSiteDistance1);
      toNextSiteDirection = toSiteDirection1;
    }
    
    /**
     * 由于站点间距离计算会与真实站点线路距离有误差
     * 这种误差有时会造成线路上的车辆图标不显示（因为不在我们算法的区域内）
     * 这时我们默认读取上一次的位置数据
     */
    if(parseInt(siteNumber) === 0){
      siteNumber = lastSiteNumber;
      nextSiteDistance = lastTimeData[0].nextSiteDistance;
    }
    
  } else if(latelyAroundData.length === 2){
    //siteSpacing0=latelyAroundData[0].previousStationSiteDistance;
    siteSpacing1=latelyAroundData[0].toNextSiteDistance;
    currentToSiteDistance1=latelyAroundData[0].distance;
    currentToSiteDistance2=latelyAroundData[1].distance;

    if(parseInt(latelyAroundData[0].siteNumber)===1){
      if(parseFloat(currentToSiteDistance2) <= parseFloat(siteSpacing1)){
        siteNumber = 1;
        nextSiteDistance = parseFloat(currentToSiteDistance2);
      }else if(parseFloat(currentToSiteDistance2) > parseFloat(siteSpacing1) && parseInt(currentToSiteDistance1)<=20){
        siteNumber = 1;
        nextSiteDistance = parseFloat(currentToSiteDistance1)+parseFloat(currentToSiteDistance2);
      }
    }else{
      if(parseFloat(currentToSiteDistance2) <= parseFloat(siteSpacing1) && parseFloat(currentToSiteDistance1) < parseFloat(siteSpacing1)){
        siteNumber = latelyAroundData[0].siteNumber;
        nextSiteDistance = parseFloat(currentToSiteDistance2);
      }else{
        siteNumber = latelyAroundData[1].siteNumber;
        nextSiteDistance = 0;
      }

      if(parseInt(nextSiteDistance)<=10){ //距离最后一站10m内，默认到站
        siteNumber = latelyAroundData[1].siteNumber;
      }
    }
  }

  if(parseInt(lastSiteNumber) > parseInt(siteNumber)){
    siteNumber = 0;
  }

  if(parseInt(siteNumber)>0){
    if(!isNextSiteDirection(siteNumber,nextSiteDistance,toNextSiteDirection,lastTimeData)){
      siteNumber=0;
      nextSiteDistance=0;
    }else{
      storageLastTimeData(type,simId,locationTime,siteNumber,nextSiteDistance,toNextSiteDirection)
    }
  }

  // consoleVehiclesTravelPositionData(simId,siteSpacing0,siteSpacing1,siteSpacing2,siteSpacing3,currentToSiteDistance1,currentToSiteDistance2,currentToSiteDistance3,'','','',lastTimeData[0].siteNumber,lastTimeData[0].nextSiteDistance);

  return siteNumber+","+nextSiteDistance;
} 

function consoleVehiclesTravelPositionData(simId,siteSpacing0,siteSpacing1,siteSpacing2,siteSpacing3,toSiteDistance1,toSiteDistance2,toSiteDistance3,toSiteDirection1,toSiteDirection2,toSiteDirection3,lastSiteNumber,lastNextSiteDistance){
  let arr = [];
  let obj= Object.create(null);
  obj.simId = simId;
  obj.siteSpacing0 = siteSpacing0;
  obj.siteSpacing1 = siteSpacing1;
  obj.siteSpacing2 = siteSpacing2;  
  obj.siteSpacing3 = siteSpacing3; 
  obj.toSiteDistance1 = toSiteDistance1;
  obj.toSiteDistance2 = toSiteDistance2;  
  obj.toSiteDistance3 = toSiteDistance3;
  obj.toSiteDirection1 = toSiteDirection1;
  obj.toSiteDirection2 = toSiteDirection2;  
  obj.toSiteDirection3 = toSiteDirection3; 
  obj.lastSiteNumber = lastSiteNumber;
  obj.lastNextSiteDistance = lastNextSiteDistance;
  arr.push(obj);

}

function isNextSiteDirection(currentSiteNumber,currentNextSiteDistance,currentToNextSiteDirection,lastTimeData){
  let lastSiteNumber = lastTimeData[0].siteNumber;
  let lastNextSiteDistance = lastTimeData[0].nextSiteDistance;
  let lastToNextSiteDirection = lastTimeData[0].toNextSiteDirection;
  // 这里要做个角度的判断
  if((parseInt(currentSiteNumber) === parseInt(lastSiteNumber) && (parseFloat(currentNextSiteDistance) <= parseFloat(lastNextSiteDistance)) || isSameDirection(currentToNextSiteDirection,lastToNextSiteDirection)) || parseInt(currentSiteNumber) > parseInt(lastSiteNumber)){
    return true;
  }

  return false;
}

function storageLastTimeData(type,simId,locationTime,siteNumber,nextSiteDistance,toNextSiteDirection){
  if(parseInt(siteNumber)>0){
    let arr = [];
    let obj= Object.create(null);
    obj.simId = simId;
    obj.locationTime = locationTime;
    obj.siteNumber = siteNumber;  
    obj.nextSiteDistance = nextSiteDistance; 
    obj.toNextSiteDirection = toNextSiteDirection; 
    arr.push(obj);

    setStorageItem(type+'LastTimeData'+simId,JSON.stringify(arr));
  }
}

function getLastTimeData(type,simId,locationTime){
  let lastTimeDataJson = sessionStorage.getItem(type+'LastTimeData'+simId);
  let lastTimeData = JSON.parse(lastTimeDataJson);
  if(lastTimeData !== null) {
    let lastLocationTime = new Date(Date.parse(lastTimeData[0].locationTime));
    let curLocationTime = new Date(Date.parse(locationTime));
    let lastLocationTimeAddMinute = new Date(lastLocationTime.setMinutes(lastLocationTime.getMinutes() + 3)); //上次时间添加3分钟
    if(curLocationTime < lastLocationTimeAddMinute){
      return lastTimeData;
    }
  }

  return '';
}

function storageVehiclesRunningData(type,simId,siteNumber,lastSiteNumber,nextSiteDistance,lastNextSiteDistance){
  let arr = [];
  let obj= Object.create(null);
  obj.simId = simId;
  obj.siteNumber = siteNumber;  
  obj.lastSiteNumber = lastSiteNumber; 
  obj.nextSiteDistance = nextSiteDistance;  
  obj.lastNextSiteDistance = lastNextSiteDistance; 
  arr.push(obj);

  setStorageItem(type+'VehiclesRunningData'+simId,JSON.stringify(arr));
}

function getVehiclesRunningData(type,simId){
  let vehiclesRunningDataJson = sessionStorage.getItem(type+'VehiclesRunningData'+simId);
  let vehiclesRunningData = JSON.parse(vehiclesRunningDataJson || '[]');

  return vehiclesRunningData;
}

//将时分转为时间戳
function time_to_timeStamp(time) {
  if (time !== "" && time !== null) {
    var s = "";
    var hour = time.split(":")[0];
    var min = time.split(":")[1];
    s = Number(hour * 3600) + Number(min * 60);
    return s;
  }
}
/**
 * 获取当前车速
 * @param {当前车速} speed 
 * @param {低峰期速度} lowPeakPeriodSpeed 
 * @param {高峰期速度} fastigiumSpeed 
 * @param {早高峰期} morningFastigiumTimeSlot 
 * @param {晚高峰期} nightFastigiumTimeSlot 
 * @returns 
 */
function getVehiclesSpeed(speed,lowPeakPeriodSpeed,fastigiumSpeed,morningFastigiumTimeSlot,nightFastigiumTimeSlot){
  let tempFastigiumSpeed = getFastigiumSpeed(morningFastigiumTimeSlot,fastigiumSpeed);
  if(parseInt(tempFastigiumSpeed)>0){
    return tempFastigiumSpeed;
  }
  
  tempFastigiumSpeed = getFastigiumSpeed(nightFastigiumTimeSlot,fastigiumSpeed);
  if(parseInt(tempFastigiumSpeed)>0){
    return tempFastigiumSpeed;
  }

  if(parseInt(lowPeakPeriodSpeed)>0){
    return lowPeakPeriodSpeed;
  }

  return speed;
}

/**
 * 如果高峰期存在、高峰期速度大于0，且当前时间属于高峰期内，返回高峰期速度，否则为默认值0
 * @param {高峰期时间段} fastigiumTimeSlot 
 * @param {高峰期速度} fastigiumSpeed 
 * @returns 高峰期速度
 */
function getFastigiumSpeed(fastigiumTimeSlot,fastigiumSpeed){
  let speed =0;
  if(fastigiumTimeSlot !== '' && fastigiumTimeSlot !==null){
    let fastigiumTimeSlotArr = fastigiumTimeSlot.split(',');
    if(fastigiumTimeSlotArr.length>0){
      let startTime = fastigiumTimeSlotArr[0];
      let endTime = fastigiumTimeSlotArr[1];
      let myDate = new Date();
      let hours = myDate.getHours();  
      let minutes = myDate.getMinutes();  
      let currentTime = hours + ':'+ minutes;
      let startTimeStamp = time_to_timeStamp(startTime);
      let endTimeStamp = time_to_timeStamp(endTime); 
      let currentTimeStamp = time_to_timeStamp(currentTime);
      //当前时间在高峰期内 
      if(parseInt(currentTimeStamp)>=parseInt(startTimeStamp) && parseInt(currentTimeStamp)<=parseInt(endTimeStamp) && parseInt(fastigiumSpeed)>0){
        speed = parseInt(fastigiumSpeed);
      }
    }
  }

  return speed;
}

function removeClassName(type,simId,functionName){
  let className = type+simId;
  let objs = document.getElementsByClassName(className);
  if(objs.length>0){
    eval(functionName+"('"+objs[0].id+"','"+className+"')");
  }
}

function singleVehiclesIconRemove(id,className){
  let divDom = document.getElementById(id);
  let classList = divDom.classList;
  if(classList.length>0){
    let classFilterList=[];
    classList.forEach(item=>{
      if(isIncludes(item,'carClassName')){
        classFilterList.push(item);
      }
    })
    if(classFilterList.length === 1){
      if(classFilterList[0] === className){
        divDom.classList.remove("car", className);
      }
    }else if(classFilterList.length >= 2){
      classFilterList.forEach(item=>{
        if(item === className){
          divDom.classList.remove(className);
        }
      })
    }
  }
}

function isIncludes(element,content) {
  return element.includes(content);
}

function vehiclesIconAdd(id,simId){
  let className = 'carClassName'+simId;
  let divDom = document.getElementById(id);
  if(divDom !== null){
    divDom.classList.add(className);
    if(divDom.classList.contains("car") === false){
      divDom.classList.add("car");
      divDom.classList.remove("no_car");
    }
  }
}

function singleBackgroundColorRemove(id,className){
  let divDom = document.getElementById(id);
  let classList = divDom.classList;
  if(classList.length>0){
    let classFilterList=[];
    classList.forEach(item=>{
      if(isIncludes(item,'groundColorClassName')){
        classFilterList.push(item);
      }
    })
    if(classFilterList.length === 1){
      if(classFilterList[0] === className){
        divDom.classList.remove("red", className);
        divDom.classList.add("white");
      }
    }else if(classFilterList.length >= 2){
      classFilterList.forEach(item=>{
        if(item === className){
          divDom.classList.remove(className);
        }
      })
    }
  }
}

function updateSiteLineBackgroundColor(simId,id,carImgId){
  let className = 'groundColorClassName'+simId;
  let divDom = document.getElementById(id);
  let carImgIdDom = document.getElementById(carImgId);
  if(divDom !== null && carImgIdDom !== null){
    if(carImgIdDom.classList.contains("car") === true){
      divDom.classList.add("red",className);
      divDom.classList.remove("white");
    }else {
      divDom.classList.add("white");
      divDom.classList.remove("red",className);
    }
  }
}

function singleLicensePlateRemove(id,className){
  let divDom = document.getElementById(id);
  let classList = divDom.classList;
  if(classList.length>0){
    let classFilterList=[];
    classList.forEach(item=>{
      if(isIncludes(item,'licensePlateClassName')){
        classFilterList.push(item);
      }
    })
    
    classFilterList.forEach(item=>{
      if(item === className){
        divDom.classList.remove(className);
      }
    })

    divDom.innerHTML="";
  }
}

function licensePlateAdd(id,simId,licensePlate){
  let className = 'licensePlateClassName'+simId;
  let divDom = document.getElementById(id);
  if(divDom !== null){
    divDom.classList.add(className);
    divDom.innerHTML=licensePlate;
  }
}

function currentMonthFirst(){
  let date = new Date();
  let year = date.getFullYear().toString();
  let month = date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1).toString():(date.getMonth()+1).toString();

  return year + '-' + month + '-01';
}

function currentMonthFirstLastDayArr(){
  let date = new Date();
  let year = date.getFullYear().toString();
  let month = date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1).toString():(date.getMonth()+1).toString();
  var firstData = year + '-' + month + '-01';
  var lastData = new Date(year, date.getMonth() + 1, 0);
  var lastDay = lastData.getDate();
  lastData = year + '-' + month + '-' + lastDay;

  return firstData+','+lastData;
}

/**
 * 获取当前日期
 * @returns 当前日期
 */
function currentDate(){
  let date = new Date();
  let year = date.getFullYear().toString();
  let month = date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1).toString():(date.getMonth()+1).toString();
  let day = date.getDate() < 10 ? '0'+date.getDate().toString():date.getDate().toString();
  let departureDate = year + '-' + month + '-' + day;
  return departureDate;
}

/**
 * 获取传入日期后days日期
 * @param {传入日期} date 
 * @param {往后几天} days 
 * @returns 
 */
function nextDate(date,days) {
  var date = new Date(date);
  date.setDate(date.getDate() + days);
  var year = date.getFullYear().toString();
  let month = date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1).toString():(date.getMonth()+1).toString();
  let day = date.getDate() < 10 ? '0'+date.getDate().toString():date.getDate().toString();

  return year + '-' + month + '-' + day;
}

/**
 * 获取当前日期后days日期
 * @param {往后几天} days 
 * @returns 
 */
function currentNextDate(days){
  let date = new Date();
  date.setDate(date.getDate() + days);
  var year = date.getFullYear().toString();
  let month = date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1).toString():(date.getMonth()+1).toString();
  let day = date.getDate() < 10 ? '0'+date.getDate().toString():date.getDate().toString();

  return year + '-' + month + '-' + day;
}

/**
 * 日期格式化
 * @param {传入的日期} date 
 * @returns yyyy-MM-dd
 */
function formatDate(date) {
  let year = date.getFullYear().toString();
  let month = date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1).toString():(date.getMonth()+1).toString();
  let day = date.getDate() < 10 ? '0'+date.getDate().toString():date.getDate().toString();

  return year + '-' + month + '-' + day;
}

export { getDirection,getVehiclesSpeed,getLastTimeData,compareDesc,
  getSocketCoordinateDistanceData,getVehiclesTravelPosition,getVehiclesTravelPositionByLastTimeData,
  vehiclesIconAdd,updateSiteLineBackgroundColor,removeClassName,licensePlateAdd,storageVehiclesRunningData,
  getVehiclesRunningData,currentMonthFirst,currentMonthFirstLastDayArr,currentDate,nextDate,currentNextDate,formatDate }
